'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$36() {
  this.bhB = null;
  this.bhz = null;
  this.bhA = false;
  this.bhx = null;
  this.bhy = false;
  this.bhC = false;
  this.bhD = false;
  this.bhB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$36 as $c_Lpresto_PrestoRouter$$anon$36 };
$p = $c_Lpresto_PrestoRouter$$anon$36.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$36;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$36() {
}
export { $h_Lpresto_PrestoRouter$$anon$36 as $h_Lpresto_PrestoRouter$$anon$36 };
$h_Lpresto_PrestoRouter$$anon$36.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bhB;
});
$p.t = (function() {
  if ((!this.bhA)) {
    this.bhz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bhA = true;
  }
  return this.bhz;
});
$p.ae = (function() {
  if ((!this.bhy)) {
    this.bhx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bhy = true;
  }
  return this.bhx;
});
$p.w = (function() {
  if ((!this.bhD)) {
    this.bhC = false;
    this.bhD = true;
  }
  return this.bhC;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$36 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$36, "presto.PrestoRouter$$anon$36", ({
  O2: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$36 as $d_Lpresto_PrestoRouter$$anon$36 };
//# sourceMappingURL=presto.-Presto-Router$$anon$36.js.map
